<!-- 导航 -->
<style scoped>
.hearder{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
    background: #ffffff;
    z-index: 8;
}
.hearder .var{
    width: 1200px;
    height: 80px;
    margin: 0 auto;
}
.hearder .var .logoBox {
    float: left;
    width: 186.5px;
    line-height: 80px;
}
.hearder .var .logoBox img{
    width: 100%;
    height: 49px;
    vertical-align: middle;
}
.hearder .var nav{
    float: left;
    margin-left: 86px;
}
.hearder .var nav div{
    display: inline-block;
    height: 80px;
    line-height: 80px;
    font-size:16px ;
    margin: 0 35px;
    cursor: pointer;
    color: #000;
}
.hearder .var nav div .triangle,
.hearder .var nav div .triangle_top{
    display: inline-block;
    border-top: 5px solid #e0e0e0;
    border-bottom: 2px solid #fff;
    border-left: 5px solid #fff;
    border-right:5px solid #fff ;
    /* width: 1px; */
    height: 1px;
    background-color: #04a0f7;
}
.hearder .var nav div .triangle_top{
    border-bottom: 5px solid #e0e0e0;
    border-top: 2px solid #fff;
    margin-bottom: 3px;
}
.hearder .var nav div span{
    display: inline-block;
    height: 70px;
}
.hearder .var nav div.selectionItem {
    color: #04a0f7;
}
.hearder .var nav div .triangle_sel{
    border-top: 5px solid #04a0f7;
}
.hearder .var nav div .triangle_topsel{
    border-bottom: 5px solid #04a0f7;
}
.hearder .var nav div span:hover {
    color: #04a0f7;
    /* padding-bottom: 10px; */
    border-bottom: 2px solid #04a0f7;
}
.hearder .var nav div span:hover .triangle{
    border-top: 5px solid #04a0f7;
    border-bottom: 2px solid #fff;
}
.hearder .var nav div span:hover .triangle_top{
    /* border-top: 5px solid #04a0f7; */
    border-bottom: 5px solid #04a0f7;
}

.hearder .var .box{
    float:right;
    margin-right: 20px;
    line-height: 80px;
    height: 80px;
}
.hearder .var .box a{
    display: inline-block;
    /* width: 135px; */
    padding: 0 25px;
    background: #fff;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border: 1px solid #BEBEBE;
    border-radius: 4px;
    /* color: #17a7f8; */
    color: #ffffff;
    background-color: #17a7f8;
    background-color: #fff;
     color: #0D0D0D;
}
.hearder .var .box:last-child a{
    border: 1px solid #17a7f8;
    color: #ffffff;
    background-color: #17a7f8;
}
/* .hearder .var .box a:hover {
    background-color: #17a7f8;
    border: 1px solid #17a7f8;
    color: #ffffff;
} */
.hearder .child{
    background-color: rgba(255, 255, 255, 0.8);
    opacity: 1;
    display: block;
    transition: opacity 1s linear;


    /* animation: childNode 2s linear 6s; */
    /* animation-fill-mode:forwards; */
}
.hearder .childBox{
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    height: 60px;
    /* background-color: rgba(255, 255, 255, 0.6); */
}
.hearder .childBox nav{
    display: inline-block;
    line-height: 60px;
    transform: translateX(-55%);
}
.hearder .childBox nav span{
    box-sizing: border-box;
    display: inline-block;
    font-size: 16px;
    height: 60px;
    margin: 0 20px;
    cursor: pointer;
}
.hearder .childBox nav span:hover{
    
    color: #04a0f7;
    border-bottom: 2px solid #17a7f8;
}
.hearder .childBox .selChild{
    color: #04a0f7;
}

</style>
<template>
  <div>
    <div class="hearder">
        <div class="var">
            <div class="logoBox">
                <img src="@/assets/images/log_03.png" alt="">
            </div>
            <nav>
                <div 
                    v-for="(item,index) in nav" 
                    :key="index+'nav'" 
                    @click="changeRouter(index)" 
                    :class="{'selectionItem': number==index}">
                    <span  v-if="item == '产品服务'">{{item}} 
                        <span v-if="ischil" @click="noneChis"  :class="{'triangle_top':true,'triangle_topsel': number==index}"></span>
                        <span v-else @click="visChis" :class="{'triangle':true,'triangle_sel': number==index}"></span>
                    </span>
                    <span v-else>{{item}}</span>
                </div>
            </nav>
            <div class="box">
              <a href="http://5gm.richinfo.cn/dist/index.html#/register" target="_blank">注册</a>
            </div>
            <div class="box">
              <a href="http://5gm.richinfo.cn/dist/index.html#/login" target="_blank">登录</a>
            </div>
        </div>

        <div class="child" v-if="number == 1">
            <div class="childBox">
                <nav>
                    <span 
                        v-for="(item,index) in nav2" 
                        :key="index" 
                        @click="childRouter(index)" 
                        :class="{'selChild':childNumber == index}"
                    >
                    {{item}}
                    </span>
                </nav>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
        nav:["主页",'产品服务','行业应用','成为开发者','开发者文档'],
        number:0, 
        nav2:['5G消息','短信','视频短信'] ,
        childNumber:0,
        ischil:true,
    }
  },

  components: {},

  methods: {
    visChis(){
            document.querySelector('.child').style.display = 'block';
            document.querySelector('.child').style.opacity = '1';
             this.ischil = !this.ischil;
    },
    noneChis(){
        document.querySelector('.child').style.display = 'none';
        document.querySelector('.child').style.opacity = '0';

        this.ischil = !this.ischil;
    },

    // 页面切换
    changeRouter(index){
        
        // if(this.number == 1){
        //     console.log(5555);
        //     document.querySelector('.child').style.display = 'block'
        //     document.querySelector('.child').style.opacity = '1'
        // }else{
        //     document.querySelector('.child').style.display = 'none'
        //     document.querySelector('.child').style.opacity = '0'
        // }
        

        if (this.number === index) return;
        window.scrollTo(0,0);
        this.number = index;
        console.log(this.number);
        switch (index) {
            case 0:
                this.$router.push({
                    path: "/",
                    query: {
                    },
                });
            break;
            case 1:
                this.$router.push({
                    path: "/productService",
                    query: {
                    },
                });
            break;
            case 2:
                this.$router.push({
                    path: "/application",
                    query: {
                    },
                });
            break;
            case 3:
                this.$router.push({
                    path: "/becomeDeveloper",
                    query: {
                    },
                });
            break;
            case 4:
                this.$router.push({
                    path: "/developerDocumentation",
                    query: {
                    },
                });
            break;
        }
    },
    // 初始化
    initNav(name) {
        window.scrollTo(0,0);
        switch (name) {
            case '/':
                this.number = 0;
            break;
            case '/productService':
                this.number = 1;
            break;
            case '/application':
                this.number = 2;
            break;
            case '/becomeDeveloper':
                this.number = 3;
            break;
            case '/developerDocumentation':
                this.number = 4;
            break;
        }
    },
    //二级目录选择
    childRouter(index){
        window.scrollTo(0,0);
        this.childNumber  = index;
        this.$emit('childNumber',index);
        // document.querySelector('.child').style.display = 'none'
    }
  },
  watch: {
      // 监听路由变化
      '$route.path'(val) {
        this.initNav(val);
      }
  },
  mounted() {
    this.initNav(this.$route.path);
  }
}
</script>


// WEBPACK FOOTER //
// src/components/hearder.vue